import { CreateInterviewTypeFormContainerContent } from './CreateInterviewTypeFormContainerContent';
import type { CreateInterviewTypeFormContainerProps } from './types';

export type { CreateInterviewTypeFormContainerProps };

export function CreateInterviewTypeFormContainer(props: CreateInterviewTypeFormContainerProps) {
  return <CreateInterviewTypeFormContainerContent {...props} />;
}
